export default "__VITE_ASSET__dab02356__"